import { hideVisually, rem, rgba } from 'polished';
import styled from 'styled-components/macro';

export const StyledLanguageNav = styled.nav`
  position: relative;
  color: ${({ theme }) => theme.colors.cross.grayson};
  text-transform: uppercase;
  font-size: ${rem('14px')};
  font-weight: 700;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    min-width: ${rem('50px')};
  }
`;

export const StyledLanguageNavButton = styled.button`
  display: flex;
  align-items: center;
  padding: ${rem('8px')} 0;
  color: inherit;
  font-weight: inherit;
  text-transform: inherit;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  > svg {
    width: ${rem('20px')};
    height: auto;
    margin-right: ${rem('8px')};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.cross.black};

    svg path {
      fill: ${({ theme }) => theme.colors.cross.black};
    }
  }

  > span {
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
      display: none;
    }
  }
`;

export const StyledLanguageNavContent = styled.div`
  position: absolute;
  top: ${rem('30px')};
  padding-top: ${rem('10px')};

  &[aria-hidden='true'] {
    ${hideVisually()};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    right: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    left: 0;
  }
`;

export const StyledLanguageNavList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: ${rem('24px')};
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: ${rem('8px')};
  box-shadow: 0 0 ${rem('8px')} 0
    ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
`;

export const StyledLanguageNavListButton = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  background-color: transparent;
  border: none;
  appearance: none;
  color: inherit;
  cursor: pointer;
  font-weight: inherit;
  text-align: right;
  text-transform: uppercase;

  &:focus {
    outline: none; //TODO add proper focus style
  }

  &:hover {
    color: ${({ theme }) => theme.colors.cross.black};
  }
`;

export const StyledLanguageNavListItem = styled.li`
  list-style: none;

  &:first-child {
    ${StyledLanguageNavListButton} {
      color: ${({ theme }) => theme.colors.landlord.main};
      cursor: default;
    }
  }

  &:not(:first-child) {
    margin-top: ${rem('16px')};
  }
`;
